export const wellnessConcerns = [
  { value: 'anxiety', label: 'Anxiety' },
  { value: 'stress', label: 'Stress' },
  { value: 'depression', label: 'Depression' },
  { value: 'insomnia', label: 'Insomnia' },
  { value: 'sleep-issues', label: 'Sleep Issues' },
  { value: 'back-pain', label: 'Back Pain' },
  { value: 'chronic-pain', label: 'Chronic Pain' },
  { value: 'digestive-issues', label: 'Digestive Issues' },
  { value: 'fatigue', label: 'Fatigue' },
  { value: 'burnout', label: 'Burnout' },
  { value: 'trauma', label: 'Trauma' },
  { value: 'relationships', label: 'Relationships' },
  { value: 'self-esteem', label: 'Self-Esteem' },
  { value: 'mindfulness', label: 'Mindfulness' },
  { value: 'meditation', label: 'Meditation' },
  { value: 'yoga', label: 'Yoga' },
  { value: 'nutrition', label: 'Nutrition' },
  { value: 'weight-loss', label: 'Weight Loss' },
  { value: 'detox', label: 'Detox' },
  { value: 'fertility', label: 'Fertility' },
  { value: 'pregnancy', label: 'Pregnancy' },
  { value: 'postpartum', label: 'Postpartum' },
  { value: 'children-health', label: 'Children Health' },
  { value: 'family-wellness', label: 'Family Wellness' },
  { value: 'corporate-wellness', label: 'Corporate Wellness' },
  { value: 'career-coaching', label: 'Career Coaching' },
  { value: 'life-coaching', label: 'Life Coaching' },
  { value: 'spiritual-growth', label: 'Spiritual Growth' },
  { value: 'energy-healing', label: 'Energy Healing' },
  { value: 'reiki', label: 'Reiki' },
  { value: 'acupuncture', label: 'Acupuncture' },
  { value: 'massage-therapy', label: 'Massage Therapy' },
  { value: 'osteopathy', label: 'Osteopathy' },
  { value: 'naturopathy', label: 'Naturopathy' },
  { value: 'herbal-medicine', label: 'Herbal Medicine' },
  { value: 'aromatherapy', label: 'Aromatherapy' },
  { value: 'sound-healing', label: 'Sound Healing' },
  { value: 'breathwork', label: 'Breathwork' },
];
